// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseFooter__root___FFrJt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseFooter/EnterpriseFooter.scss
// module id = 1010
// module chunks = 0